import { CardProps } from '../card';
import leadership from '../../../../assets/images/principles/leadership.svg';
import accessibility from '../../../../assets/images/principles/accessibility.svg';
import adaptivity from '../../../../assets/images/principles/adaptivity.svg';
import skills from '../../../../assets/images/principles/skills.svg';
import partnership from '../../../../assets/images/principles/partnership.svg';
import support from '../../../../assets/images/principles/support.svg';
import transparency from '../../../../assets/images/principles/transparency.svg';
import innovation from '../../../../assets/images/principles/innovation.svg';
import holistic from '../../../../assets/images/principles/holistic.svg';

export const principlesItems: CardProps[] = [
  { title: 'principles-1.title', content: ['principles-1.content'], icon: leadership },
  { title: 'principles-2.title', content: ['principles-2.content'], icon: accessibility },
  { title: 'principles-3.title', content: ['principles-3.content'], icon: adaptivity },
  { title: 'principles-4.title', content: ['principles-4.content'], icon: skills },
  { title: 'principles-5.title', content: ['principles-5.content'], icon: partnership },
  { title: 'principles-6.title', content: ['principles-6.content'], icon: support },
  { title: 'principles-7.title', content: ['principles-7.content'], icon: transparency },
  { title: 'principles-8.title', content: ['principles-8.content'], icon: innovation },
  { title: 'principles-9.title', content: ['principles-9.content'], icon: holistic },
];
